export default "__VITE_ASSET__B71l0BHY__"